import React, { useEffect, useState } from 'react';
import { Eye, ChevronUp, ChevronDown } from 'react-feather';
import Table from '../../../components/Table/Table';
import IconCounter from '../../../components/IconCounter';
import TickerSectorItem from '../../../components/TickerSectorItem';
import { useRemote, useStorage } from '../../../Utils/Utils';
import { format, sub } from 'date-fns';
import AnalyticsHeader from './AnalyticsHeader'
import Divider from '../../../components/Divider';
import { useHistory } from 'react-router-dom';

const TopTickers = ({ dateRanges }) => {
	const remote = useRemote();
	const storage = useStorage();
	const history = useHistory() 
	const [allData, setAllData] = useState([])
	const [tickerData, setTickerData] = useState([])
	const [allTickers, setAllTickers] = useState([])
	const [allGroups, setAllGrpups] = useState([])
	const [tickersDateRange, setTickersDateRange] = useState(dateRanges[0]);
	const [sortingColumn, setSortingColumn] = useState({ column: "PortalViews", ascending: false })

	const end = format(new Date(), 'yyyy-MM-dd')

	useEffect(() => {
		storage.getOrFetch(`/crm/tickers`).then(setAllTickers)
		storage.getOrFetch(`/crm/groupings/${1}`).then((fetchedGrouping) => {
			setAllGrpups(fetchedGrouping ? fetchedGrouping.groups : [])
		})
	}, []);

	useEffect(() => {
		let time = { months: 6 }

		if (tickersDateRange) time = tickersDateRange

		let date = typeof tickersDateRange === "string" ? tickersDateRange : format(sub(new Date(), time), "yyyy-MM-dd")

		remote.get(`/analytics/aggregates/documents?from=${date}&to=${end}`).then((stats) => {
			const tickerAggregate = {};

			stats.forEach(r => {
				const tickerStats = tickerAggregate[r.ticker] || { ticker: r.ticker, count: 0, minutes: 0, uniqueViews: 0 };
				tickerStats.uniqueViews += r.uniqueViews
				tickerStats.noteId = r.documentId;
				tickerAggregate[r.ticker] = tickerStats;
			})
			const tickerAsArray = Object.keys(tickerAggregate).map(key => tickerAggregate[key])
			setAllData(tickerAsArray)
			// const dummyData = [
			// 	{uniqueViews: 30, publishedBy: 'Leo Rey', title: 'Queso Feliz', publishedDate: '2025-01-23', ticker: 'MEL.NZ', count: 4, minutes: 80}, 
			// 	{uniqueViews: 10, publishedBy: 'Sonia Campellan', title: 'Viva si', publishedDate: '2024-08-15', ticker: 'ERD.NZ', count: 6, minutes: 120},
			// 	{uniqueViews: 35, publishedBy: 'Jairo Sequerira', title: 'Oseano profundo', publishedDate: '2025-01-04', ticker: 'MCY.NZ', count: 4, minutes: 66}, 
			// 	{uniqueViews: 14, publishedBy: 'Sonia Campellan', title: 'Launa y todo sereno', publishedDate: '2024-03-10', ticker: 'EBO.NZ', count: 6, minutes: 79},
			// 	{uniqueViews: 20, publishedBy: 'Jairo Sequerira', title: 'La vida se abre camino', publishedDate: '2025-09-15', ticker: 'Utilities', count: 4, minutes: 92}, 
			// 	{uniqueViews: 19, publishedBy: 'Miriam Parra', title: 'Geton feo', publishedDate: '2024-11-19', ticker: 'AIA.NZ', count: 6, minutes: 46},
			// 	{uniqueViews: 7, publishedBy: 'Leo Rey', title: 'Rebasalo hermano', publishedDate: '2025-02-21', ticker: 'SPK.NZ', count: 4, minutes: 111}, 
			// 	{uniqueViews: 4, publishedBy: 'Miriam Parra', title: 'Jamas voy a decir eso', publishedDate: '2024-10-24', ticker: 'IFT.NZ', count: 6, minutes: 108},
			// ]
			// setAllData(dummyData)
		});
	}, [tickersDateRange]);

	useEffect(() => {
		sortTable(sortingColumn.column, 'descending')
	}, [allData])

	function sortTable(column, string) {
		let tableData = allData

		const ascending = sortingColumn.column === column ? string && string === 'descending' ? false : !sortingColumn.ascending : true
		switch (column) {
			case "Minutes":
				tableData.sort((a, b) => ascending ? a.minutes - b.minutes : b.minutes - a.minutes)
				break;
			case "PortalViews":
				tableData.sort((a, b) => ascending ? a.uniqueViews - b.uniqueViews : b.uniqueViews - a.uniqueViews)
				break;
			default:
				break;
		}
		const topFive = tableData.slice(0, 5)
		setSortingColumn({ column: column, ascending: ascending })
		setTickerData(topFive)
	}

	return <>
		<div className='db-table-header'>
			<AnalyticsHeader dateRanges={dateRanges} timeFrame={tickersDateRange} setTimeFrame={setTickersDateRange}>Tickers - Most Viewed</AnalyticsHeader>
			<Divider vertical style={{ marginBottom: '1.5rem', height: 16 }} />
			<div className='db-table-header-sorting-icons'>
				<div className='sorting-header' onClick={() => sortTable("PortalViews")}>
					<Eye className="colour-text-primary" size={16} />
					{sortingColumn && sortingColumn.column === "PortalViews" && sortingColumn.ascending === true ?
						<ChevronUp className="colour-text-primary" size={12} /> :
						<ChevronDown className={sortingColumn && sortingColumn.column === "PortalViews" ? "colour-text-primary" : "colour-text-neutral-dark-30"} size={12} />
					}
				</div>
			</div>
		</div>
		<TickerTable data={tickerData} changeRoute={(url) => history.push(url)} allTickers={allTickers} allGroups={allGroups} />
	</>
}

const TickerTable = ({ data, changeRoute, allTickers, allGroups }) => {
	const colWidths = ["90%", "150px"];

	function handleOnClick(research) {
		if (allTickers && allTickers.length > 0 && research.ticker?.includes(".")) {
			const ticker = allTickers.find(t => t.ric && t.ric === research.ticker)
			return ticker ? changeRoute(`/analytics/tickers/${ticker.id}`) : null
		} else if (allGroups && allGroups.length > 0 && !research.ticker?.includes(".")) {
			const group = allGroups.find(g => g.groupName === research.ticker)
			return group ? changeRoute(`/analytics/group/${group.id}`) : null

		} else return null
	}

	function getImage(research) {
		if (allTickers && allTickers.length > 0 && research.ticker?.includes(".")) {
			const ticker = allTickers.find(t => t.ric && t.ric === research.ticker)
			return ticker ? `/api/public/images/ticker/${ticker.id}.png` : null
		} else if (allGroups && allGroups.length > 0 && !research.ticker?.includes(".")) {
			const group = allGroups.find(g => g.groupName === research.ticker)
			return group ? `/api/public/images/group/${group.id}.png` : null
		} else return null
	}

	const dataMap = () => data && data.map((research, idx) => {
		return (
			<tr key={idx} className="cursor-pointer" onClick={() => handleOnClick(research)}>
				<td>
					<TickerSectorItem size="m" label={research.ticker} image={getImage(research)} />
				</td>
				<td className="table-action-icons transition-fade-in-slow">
					<div className='top-research-icons top-tickers-viewed-icons'>
						<IconCounter icon={<Eye />} tooltip="Views" dataAvailable count={research.uniqueViews} />
					</div>
				</td>
			</tr>
		);
	});

	return <Table suggestionMessage rowSize="s" colWidths={colWidths} dataMap={dataMap()} />

}

export default TopTickers;